import { render, staticRenderFns } from "./AdvDioptraProductTabs.vue?vue&type=template&id=3e6ca89f&scoped=true"
import script from "./AdvDioptraProductTabs.vue?vue&type=script&lang=js"
export * from "./AdvDioptraProductTabs.vue?vue&type=script&lang=js"
import style0 from "./AdvDioptraProductTabs.vue?vue&type=style&index=0&id=3e6ca89f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6ca89f",
  null
  
)

export default component.exports